<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4: AppLink(:to="item.url" :title="item.title") {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    AppTitle.u-mb-xs(:title="$t('sec3')" tag="h2")
    .grid.is-ultrawide-6.is-widescreen-7.is-desktop-9.is-tablet-10
      .column
        p.u-mb-xs.u-font-massive {{$t('sec3Desc')}}
    AppLink(to="/culture" class="button-link ") {{$t('learnMore')}}

  section.u-mt-md
    AppTitle.u-mb-xs(:title="$t('sec4')" tag="h2")
    .grid.is-ultrawide-6.is-widescreen-7.is-desktop-9.is-tablet-10
      .column
        p.u-mb-xs.u-font-massive {{$t('sec4Desc')}}
    AppLink(to="/impact/reports" class="button-link ") {{$t('sec4Cta')}}


  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"People",
    "pageDesc":"Empowering people to discover their potential and contribute for a better world.",
    "mantra":"Better tomorrow for| more humans.",
    "mantraDesc":"By focusing on education, providing decent work opportunities and fighting all types of discrimation, we guarantee that the basic needs are fulfilled and more people are innovating for a better world.",
    "sec1":"Areas of |action",
    "sec1Items":{
      "1":{
        "title":"Education",
        "desc":"Quality education unlocks opportunities of prosperity. And we believe it's an act of justice to make these opportunities available for everyone."
      },
      "2":{
        "title":"Work conditions",
        "desc":"Supporting startups to realize their goals, achieve economic growth and provide more decent work opportunities. "
      },
      "3":{
        "title":"Gender equality",
        "desc":"Gender bias is a waste of resources. We aim to ending all acts of violence against women and empowering them to lead in their careers."
      }
    },
    "sec2":"Our |initiatives",
    "sec2Items":{
      "1":{
        "title":"Thrive",
        "desc":"We partner with promising startups and support them with the needed materials, knowledge and services to flourish and activate their full potentials.",
        "url":"/impact/initiatives/thrive"
      },
      "2":{
        "title":"Classroom",
        "desc":"Touring the world to provide education for all ages and in different fields hoping to enable more people to reach a decent standard of living.",
        "url":"/impact/initiatives/classroom"
      },
      "3":{
        "title":"Empower",
        "desc":"Supporting women to take their first steps in the IT world through on ground activities and resources.",
        "url":"/impact/initiatives/empower"
      }
    },
    "sec3":"Baianat culture",
    "sec3Desc":"We foster a culture of stress free-productivity. Where everyone works on things they love and have the support needed. This happens through our consolidated learning paths, daily workshops and talks that focus on Baianaters’ personal and technical development.",
    "sec4":"Our performance",
    "sec4Desc":"We appreciate people and believe that everyone has something to give for humanity.  Discrimination on any basis is forbidden as we respect the differences that made us who we are today.",
    "sec4Cta":"Go to reports"
  },
  "ar": {
    "pageTitle":"الأفراد",
    "pageDesc":"نساعد جميع الأفراد على اكتشاف إمكاناتهم والمساهمة في إنشاء عالم أفضل خاص بهم.",
    "mantra":"غد أفضل |لجميع البشر.",
    "mantraDesc":"من خلال التركيز على التعليم، ومحاولة توفير فرص عمل لائقة ومكافحة جميع أنواع التمييز، فإننا نعمل على ضمان جميع الاحتياجات الأساسية وتساعد الأشخاص على المزيد من الابتكار من أجل عالم أفضل. ",
    "sec1":"القضايا التي |نتبناها",
    "sec1Items":{
      "1":{
        "title":"التعليم",
        "desc":"التعليم الجيد يوفر فرص أفضل للحياة. في بيانات نؤمن أنه من العدل توفير فرصة التعليم للجميع."
      },
      "2":{
        "title":"ظروف العمل",
        "desc":"ندعم الشركات الناشئة لتحقيق أهدافها وتحقيق النمو الاقتصادي الذي تسعى إليه وتوفير المزيد من فرص العمل اللائق لجميع أفرادها."
      },
      "3":{
        "title":"المساواة بين الجنسين",
        "desc":"التحيز بين الجنسين ما هو إلا مضيعة للوقت واهدار للمجهود. نهدف إلى إنهاء جميع أعمال العنف ضد المرأة وتمكينها من القيادة في حياتها المهنية."
      }
    },
    "sec2":"مبادراتنا",
    "sec2Items":{
      "1":{
        "title":"نماء",
        "desc":"نتشارك مع الشركات الناشئة الواعدة وندعمها بالموارد والمعرفة والخدمات اللازمة من أجل نمو وتفعيل جميع الإمكانات الكاملة.",
        "url":"/impact/initiatives/thrive"
      },
      "2":{
        "title":"الفصول الدراسية",
        "desc":"نتجول في جميع أنحاء العالم من أجل توفير التعليم لجميع الأعمال وفي مختلف المجالات سعيًا لتمكين المزيد من الناس من الوصول إلى مستوى معيشي لائق.",
        "url":"/impact/initiatives/classroom"
      },
      "3":{
        "title":"تميكن",
        "desc":"ندعم المرأة لاتخاذ خطواتها الأولى في عالم تكنولوجيا المعلومات من خلال الأنشطة والموارد الموجودة على الأرض.",
        "url":"/impact/initiatives/empower"
      }
    },
    "sec3":"ثقافة بيانات",
    "sec3Desc":"ندعم ثقافة الإنتاج الخالية من الإجهاد. حيث يعمل الجميع على الأشياء التي يحبونها ويحصلون على الدعم اللازم، يحدث هذا من خلال مسارات التعلم الموحدة وورش العمل والمحادثات اليومية التي تركز على التطوير الشخصي والتقني لفريق عمل بيانات.",
    "sec4":"الأداء والتقارير",
    "sec4Desc":"نقدر الناس ونعتقد أن كل شخص لديه ما يعطيه للبشرية. لهذا يحظر التمييز على أي أساس حيث نحترم الاختلافات التي جعلتنا ما نحن عليه اليوم.",
    "sec4Cta":"تصفح التقارير"
  }
}
</i18n>
